import styled from 'styled-components';

export const HeroImageContainer = styled.picture`
  position: absolute;
  top: 0;
  z-index: -1;
`;

export const HeroImageSrc = styled.img`
  object-fit: cover;
  max-width: 100%;
  width: 100vw;
  height: 15rem;
`;
